import { render, staticRenderFns } from "./ProjectResortCreate.vue?vue&type=template&id=675483ea&scoped=true"
import script from "./ProjectResortCreate.vue?vue&type=script&lang=js"
export * from "./ProjectResortCreate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "675483ea",
  null
  
)

export default component.exports